import { WeightSchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import {
  packingTemplateIdFormat,
  productIdFormat,
} from "@redotech/redo-ids/ids";
import { MeasurementSchema } from "@redotech/redo-inventory-common/attributes";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { PackingMode } from "./packing-mode";

export enum PackingTemplateType {
  CASE_PACK = "case_pack",
  PALLET = "pallet",
}

export const PackingTemplateTypeSchema = createEnum(PackingTemplateType, {
  enumName: "PackingTemplateType",
});

const packingTemplateTypeToPackingModeMap: Record<
  PackingTemplateType,
  PackingMode
> = {
  [PackingTemplateType.CASE_PACK]: PackingMode.CASE_PACK,
  [PackingTemplateType.PALLET]: PackingMode.PALLET,
};

export function packingTemplateTypeToPackingMode(
  type: PackingTemplateType,
): PackingMode {
  return packingTemplateTypeToPackingModeMap[type];
}

const PackingTemplateSchema_ = z.object({
  id: packingTemplateIdFormat.schema,
  productId: productIdFormat.schema,
  name: z.string(),
  barcode: z.string().nullable(),
  templateType: PackingTemplateTypeSchema,
  unitsPerBox: z.number().nullable(),
  boxWeight: WeightSchema.nullable(),
  boxLength: MeasurementSchema.nullable(),
  boxWidth: MeasurementSchema.nullable(),
  boxHeight: MeasurementSchema.nullable(),
});

export const PackingTemplateSchema: z.ZodType<PackingTemplate> =
  PackingTemplateSchema_;
export interface PackingTemplate extends z.infer<
  typeof PackingTemplateSchema_
> {}

/**
 * Rounds `units` UP to the nearest multiple of `unitsPerBox` when a valid
 * packing template is present. Zero stays zero. No-ops when unitsPerBox is
 * null/undefined or <= 1.
 */
export function roundToUnitsPerBox(
  units: number,
  unitsPerBox: number | null | undefined,
): number {
  if (units > 0 && unitsPerBox && unitsPerBox > 1) {
    return Math.ceil(units / unitsPerBox) * unitsPerBox;
  }
  return units;
}
